export type {
  ResendAccessCodeMutation as ResendAccessCode,
  ResendAccessCodeMutationVariables as ResendAccessCodeVariables,
} from '../generated/attendee-types';

export {ResendAccessCodeMutation} from './queries';
